<template>
  <mu-drawer @hide="handleHide"
             @close="handleClose"
             :open="open"
             :docked="docked"
             :overlay="docked"
             class="app-drawer"
             :zDepth="1">
    <mu-appbar :zDepth="0"
               class="exmaples-nav-appbar">
      <a class="exmaples-appbar-title">欢迎 {{user.managerName}}</a>
      <!-- <mu-badge content="rc" class="exmaples-version" secondary/>  @click="handleMenuChange('#/index')" -->
    </mu-appbar>
    <mu-divider />
    <div class="exmaple-drawer-content">
      <mu-list style="height: 100%"
               @change="handleMenuChange"
               :value="menuVal">
        <mu-list-item v-for="item in menuTree"
                      :value=" item.v ? '#/'+item.v : undefined"
                      :toggleNested="!item.l"
                      :open="item.l"
                      :title="item.t">
          <mu-list-item v-for="i in item.s"
                        :value="'#/'+i.v"
                        :title="i.t"
                        slot="nested" />
        </mu-list-item>
      </mu-list>
    </div>
  </mu-drawer>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { check } from '../permission.js'

let fullMenuTree = [
  { l: true, v: 'home-page', t: '首页', s: [] },
  { l: true, v: 'calendar-dish-template', t: '日历排菜', s: [] },
  { l: true, v: 'order-query', t: '订单查询', s: [] },
  { l: true, v: 'base-categories', t: '基础菜品库', s: [] },
  { l: true, v: 'advice-manage', t: '未读医嘱', s: [] },
  { l: true, v: 'patient-order-stat', t: '病人点餐情况', s: [] },
  { l: true, v: 'patient-beds', t: '病人床位列表', s: [] },
  {
    t: '公交专用报表',
    s: [
      { v: 'bus-finace-report', t: '净菜营收报表' },
      { v: 'bus-purchasing-list', t: '净菜采购清单' }
    ]
  },
  {    t: '日常清单',
    s: [
      { v: 'matirial-purchasing-list', t: '采购清单' },
      { v: 'cooking-list', t: '烧制清单汇总' },
      { v: 'cooking-list-detail', t: '烧制清单' }
    ]
  },
  {
    t: '日常操作',
    s: [
      { v: 'dish-setting', t: '手动排菜' },
      { v: 'template-dish-arrangement', t: '模板排菜' },
      { v: 'name-dish-list', t: '命名排菜' },
      { v: 'account-withdraw', t: '账号提现' },
      { v: 'batch-dish-statics', t: '分批次菜品统计' },
      { v: 'order-delivery', t: '订单配送' },
      { v: 'subscriber-list', t: '订阅者列表' },
      { v: 'subscriber-listxcc', t: '三方支付对账单' },
      { v: 'administrator-takesmeal', t: '管理员取餐' }
    ]
  },
  {
    t: '充值冲红',
    s: [
      { v: 'cash-recharge', t: '现金充值' },
      { v: 'fast-recharge', t: '快速充值' },
      { v: 'cash-print', t: '打印收据' },
      { v: 'cash-red', t: '现金冲红' },
      { v: 'supplement-recharge', t: '餐补充值' },
      { v: 'supplement-red', t: '餐补冲红' },
      { v: 'meal-supply-setting', t: '下月餐补额度设置' },
      { v: 'recharge-record-query', t: '充值记录查询' },
      { v: 'recharge-monthly-report', t: '充值月报表' },
      { v: 'monthly-statistical-statement', t: '月统计报表' },
    ]
  },
  {
    t: '设置',
    s: [
      { v: 'usergroup-list', t: '用户组列表' },
      { v: 'autopay-list', t: '用户组扣款设置' },
      { v: 'random-discount-setting', t: '随机优惠活动设置' },
      // { v: 'stall-setting', t: '食堂档口设置'},
      { v: 'department-setting', t: '部门设置' },
      { v: 'position-setting', t: '职务设置' },
      { v: 'hallop-setting', t: '食堂操作员设置' },
      { v: 'waiter-setting', t: '点餐员设置' },
      { v: 'hall-setting', t: '食堂设置' },
      { v: 'period-name-setting', t: '餐段名称设置' },
      { v: 'period-setting', t: '餐段设置' },
      { v: 'batch-setting', t: '分批次就餐设置' },
      { v: 'label-setting', t: '菜品标签设置' },
      { v: 'wehall-setting', t: '微信食堂设置' },
      { v: 'employee-reset-password', t: '重置密码' },
      { v: 'employee-setting', t: '员工设置' },
      { v: 'discount-list', t: '优惠活动设置' },

      { v: 'employee-name-modify', t: '修改员工姓名' },
      { v: 'staffcar-setting', t: '办卡工本费设置' },
      { v: 'recharge-setting', t: '充值金额设置' },
      { v: 'makeup-car', t: '补卡' },
      { v: 'change-car', t: '换卡' },
      { v: 'checkout-car', t: '退卡' },
      { v: 'face-list', t: '人脸数据录入' }
    ]
  },
  {
    t: '操作员/点餐员统计',
    s: [
      { v: 'ayi-order-statics', t: '点餐员订单统计' },
      { v: 'op-order-statics', t: '操作员订单统计' },
      { v: 'ayi-on-accounts-query', t: '点餐员挂账对账查询' }
    ]
  },
  {
    t: '系统设置',
    s: [
      { v: 'manager-setting', t: '管理员设置' }
    ]
  },
  {
    t: '查询&统计',
    s: [
      { v: 'department-meal-statics', t: '部门就餐情况统计' },
      { v: 'consume-dish-statics', t: '菜品消费统计' },
      { v: 'consume-person-statics', t: '就餐人员统计' },
      { v: 'hall-revenue-statics', t: '食堂营收查询' },
      { v: 'expenses-record-statics', t: '消费记录查询' },
      { v: 'consume-time-statics', t: '就餐高峰统计' },
      { v: 'expenditure-quantity-statics', t: '消费额点菜量统计' },
      { v: 'withdrawals', t: '对账单列表' },
      { v: 'delayUploadOrders-search', t: '延迟上传订单查询' },
      { v: 'refund-statics', t: '批量扣款记录查询' },
      { v: 'poundage-list', t: '工本费' },
      { v: 'withdrawal-list', t: '提现记录查询' },
      { v: 'asyn-list', t: '导出任务' },
      { v: 'outPayTradeNo-query', t: '充值未到账查询' },
      { v: 'health-query', t: '每日健康打卡统计' },
    ]
  },
  {
    t: '批量操作',
    s: [
      { v: 'subside-operate', t: '上传餐补数据' },
      { v: 'subside-operate2', t: '考勤餐补数据' },
      { v: 'card-operate', t: '上传员工卡数据' },
      { v: 'employee-operate', t: '上传员工数据' },
      { v: 'upload-img', t: '上传图片' }
    ]
  },
  {
    t: '用户评价',
    s: [
      { v: 'dish-comment-query', t: '菜品评价记录查询' },
      { v: 'dish-comment-statics', t: '菜品评价统计' },
      { v: 'comment-score-statics', t: '评价日历' },
      { v: 'order-evaluate-statics', t: '订单评论统计' },
      { v: 'order-evaluate-search', t: '订单评论搜索' }
    ]
  },
  { l: true, v: 'certificate-management', t: '证书管理', s: [] }
]

export default {
  props: {
    open: {
      type: Boolean,
      default: true
    },
    docked: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      menuVal: '#/',
      menuTree: []
    }
  },
  computed: {
    ...mapState({ user: state => state.user }),
    lang () {
      return Vue.config.lang
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    handleMenuChange (val) {
      this.menuVal = val
      if (this.docked) {
        window.location.hash = this.menuVal
      } else {
        this.changeHref = true
      }
      this.$emit('change', val)
    },
    handleHide () {
      if (!this.changeHref) return
      window.location.hash = this.menuVal
      this.changeHref = false
    },
    changeLang (lang) {
      Vue.config.lang = lang
      window.localStorage.setItem('lang', lang)
    }
  },
  mounted () {
    this.menuTree = fullMenuTree.reduce((acc, item) => {
      if (item.l && check('query', item.v)) {
        acc.push(item)
      }
      if (!item.l) {
        let subtree = item.s.reduce((sacc, subitem) => {
          if (check('query', subitem.v)) {
            sacc.s.push(subitem)
          }
          return sacc
        }, { l: false, t: item.t, s: [] })
        if (subtree.s.length > 0) {
          acc.push(subtree)
        }
      }
      return acc
    }, [])
    this.menuVal = window.location.hash
    window.addEventListener('hashchange', () => {
      this.menuVal = window.location.hash
    })
  }
}
</script>

<style lang="less">
.app-drawer {
  display: flex;
  flex-direction: column;
}

.exmaples-nav-appbar.mu-appbar {
  flex-shrink: 0;
}
.exmaple-drawer-content {
  flex: 1;
  .scrollable();
  .no-scrollbar();
}
.scrollable() {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.exmaples-appbar-title {
  color: inherit;
  display: inline-block;
}
.no-scrollbar() {
  &::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
    -webkit-appearance: none;
    opacity: 0 !important;
  }
}
.exmaples-nav-sub-header {
  padding-left: 34px;
}

.mu-lang-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  margin-top: 8px;
  padding-left: 16px;
  padding-right: 40px;
  font-size: 16px;
}

.mu-lang {
  color: inherit;
  margin-left: 2px;
  margin-right: 2px;
  &:last-child {
    margin-right: 0;
  }
  &:hover,
  &.active {
    color: #ff5252;
  }
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track-piece {
  background-color: #eee;
  margin: -2px;
}
::-webkit-scrollbar-thumb {
  background: #aaa;
  min-height: 150px;
  min-width: 150px;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:vertical:hover {
  background: #555555;
}
::-webkit-scrollbar-thumb:horizontal:hover {
  background: #555555;
}
</style>



// WEBPACK FOOTER //
// app-nav.vue?5396d363